import { Link, useLocation, useNavigate } from "react-router-dom";
import { GearSix, House, Target, Coins, ChartLineUp, BookOpen, SignOut } from "@phosphor-icons/react";
import { useAuth } from "../../context/AuthContext";
import { logoutUser } from "../../lib/api";

export const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isSettings = location.pathname === "/settings";
  const { user, isSubscribed, setUser } = useAuth();

  const handleLogout = async () => {
    try {
      await logoutUser();
    } finally {
      setUser(false);
      navigate("/login");
    }
  };

  if (!user || !isSubscribed) {
    return (
      <header className="sticky top-0 z-40 border-b border-white/10 bg-eb-bg/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between gap-2 px-3 sm:px-6">
          <Link
            to="/"
            data-testid="nav-logo-link"
            className="shrink-0 font-heading text-lg font-black uppercase tracking-tighter text-white sm:text-2xl"
          >
            EDGE<span className="text-eb-accent">BALL</span>
          </Link>
          {user && (
            <button
              data-testid="nav-logout-button"
              onClick={handleLogout}
              className="flex items-center gap-1.5 rounded-md px-2 py-2 font-heading text-sm uppercase tracking-wide text-zinc-500 transition-colors hover:text-zinc-300"
            >
              <SignOut size={16} weight="bold" /> Log Out
            </button>
          )}
        </div>
      </header>
    );
  }

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-eb-bg/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between gap-2 px-3 sm:px-6">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="shrink-0 font-heading text-lg font-black uppercase tracking-tighter text-white sm:text-2xl"
        >
          EDGE<span className="text-eb-accent">BALL</span>
        </Link>
        <nav data-testid="nav-links" className="flex items-center gap-0.5 overflow-x-auto sm:gap-2">
          <Link
            to="/"
            data-testid="nav-dashboard-link"
            title="Model Projections"
            className={`flex items-center gap-1.5 rounded-md px-2 py-2 font-heading text-sm uppercase tracking-wide transition-colors sm:px-3 ${
              location.pathname === "/" ? "text-white" : "text-zinc-500 hover:text-zinc-300"
            }`}
          >
            <House size={16} weight="bold" />
            <span className="hidden sm:inline">Model Projections</span>
          </Link>
          <Link
            to="/best-bets"
            data-testid="nav-best-bets-link"
            title="Largest Leans"
            className={`flex items-center gap-1.5 rounded-md px-2 py-2 font-heading text-sm uppercase tracking-wide transition-colors sm:px-3 ${
              location.pathname === "/best-bets" ? "text-white" : "text-zinc-500 hover:text-zinc-300"
            }`}
          >
            <Target size={16} weight="bold" />
            <span className="hidden sm:inline">Largest Leans</span>
          </Link>
          <Link
            to="/kalshi-big-money"
            data-testid="nav-kalshi-big-money-link"
            title="Kalshi Big Money"
            className={`flex items-center gap-1.5 rounded-md px-2 py-2 font-heading text-sm uppercase tracking-wide transition-colors sm:px-3 ${
              location.pathname === "/kalshi-big-money" ? "text-white" : "text-zinc-500 hover:text-zinc-300"
            }`}
          >
            <Coins size={16} weight="bold" />
            <span className="hidden sm:inline">Kalshi Big Money</span>
          </Link>
          <Link
            to="/line-movement"
            data-testid="nav-line-movement-link"
            title="Line Movement"
            className={`flex items-center gap-1.5 rounded-md px-2 py-2 font-heading text-sm uppercase tracking-wide transition-colors sm:px-3 ${
              location.pathname === "/line-movement" ? "text-white" : "text-zinc-500 hover:text-zinc-300"
            }`}
          >
            <ChartLineUp size={16} weight="bold" />
            <span className="hidden sm:inline">Line Movement</span>
          </Link>
          <Link
            to="/how-to-use"
            data-testid="nav-how-to-use-link"
            title="How to Use"
            className={`flex items-center gap-1.5 rounded-md px-2 py-2 font-heading text-sm uppercase tracking-wide transition-colors sm:px-3 ${
              location.pathname === "/how-to-use" ? "text-white" : "text-zinc-500 hover:text-zinc-300"
            }`}
          >
            <BookOpen size={16} weight="bold" />
            <span className="hidden sm:inline">How to Use</span>
          </Link>
          <Link
            to="/settings"
            data-testid="nav-settings-link"
            title="Settings"
            className={`flex items-center gap-1.5 rounded-md px-2 py-2 font-heading text-sm uppercase tracking-wide transition-colors sm:px-3 ${
              isSettings ? "text-white" : "text-zinc-500 hover:text-zinc-300"
            }`}
          >
            <GearSix size={16} weight="bold" />
            <span className="hidden sm:inline">Settings</span>
          </Link>
          <button
            data-testid="nav-logout-button"
            onClick={handleLogout}
            title="Log Out"
            className="flex items-center gap-1.5 rounded-md px-2 py-2 font-heading text-sm uppercase tracking-wide text-zinc-500 transition-colors hover:text-zinc-300 sm:px-3"
          >
            <SignOut size={16} weight="bold" />
            <span className="hidden sm:inline">Log Out</span>
          </button>
        </nav>
      </div>
    </header>
  );
};
